/**
 * Expiry Reason active period
 */
export const MAX_DAYS = 730; // 2 years
export const MAX_WEEKS = 104; // 2 years
export const MAX_MONTHS = 48; // 4 years

/**
 * Expiry Reason waring period i.e warn the user 3 days before a reason expires.
 */
export const MIN_DAYS_WARNING = 0; // Zero means the feature is disabled
export const MAX_DAYS_WARNING = 255; // From 1 to 2555 days before a reason expires, we can warn the user.

export const EXPIRY_UNIT_TYPE = {
    DAYS: 1,
    WEEKS: 2,
    MONTHS: 3
};

/**
 * Expiry Reason Assignment.
 */
export type ASSIGNING_TYPE =  "MEMBERS" | "EXPIRY_REASONS"